import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { ApplyPromoCodeRequest, BookingSessionResponse } from '../../types/booking-session.js'

import { apiClient } from '../../lib/client.js'
import { syncBookingSessionCache } from './cache.js'

export const useApplyPromoCode = (sessionId: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (data: ApplyPromoCodeRequest) => {
      const response = await apiClient.client.post<BookingSessionResponse>(
        `/booking-session/${sessionId}/promo-code`,
        data
      )
      return response.data
    },
    onSuccess: (data) => {
      syncBookingSessionCache(queryClient, data)
    },
  })
}
